import To from 'await-to-js'
// import { _ } from 'core-js'
import encodeUrl from 'encodeurl'
import qs from 'qs'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinTagObject = {
  async apiImportExportTags(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
      objToExportInfo: {},
    }
  ) {
    let [err, res] = [null, null]
    const config = {
      responseType: 'arraybuffer',
      header: {
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    }
    const instance = axios.create(config)
    switch (arg.method) {
      case 'ExportFilterTag':
        // TODO need check the url
        const obj = {
          siteId: ' ',
          keywords: ' ',
          classIds: [],
        }
        if (arg.params) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(plantInstance.post('/api/Tag/ExportFilterTagInfoToFile', obj))
        break
      case 'DownloadResult':
        // TODO need check the url
        ;[err, res] = await To(instance.get('/api/Tag/DownloadResultFile/'))
        break
      case 'ExportTagInfo':
        // TODO need double check why here used post and post what
        ;[err, res] = await To(
          plantInstance.post('/api/Tag/ExportTagInfoToFile', arg.objToExportInfo)
        )
        break
      // 下载二维码
      case 'DownLoadQrCode':
        // TODO need double check why here used post and post what
        ;[err, res] = await To(plantInstance.post(`/api/tag/tagqrcodes/${arg.siteId}`, arg.params))
        break
      case 'ExportTagClassById':
        // TODO need double check why here used post and post what
        ;[err, res] = await To(instance.post('/api/TagClass/handover/ExportByIdAsync', arg.ids))
        break
      case 'ExportTagAttrById':
        // TODO need double check why here used post and post what
        ;[err, res] = await To(
          instance.post(`/api/TagAttributeTemplate/exportbyidasync/${arg.params.type}`, arg.ids)
        )
        break
      case 'exportTagClassTemplate':
        ;[err, res] = await To(instance.get('/api/TagClass/downloadasync'))
        break
      case 'exportTagAttrTemplate':
        ;[err, res] = await To(instance.get('/api/TagAttributeTemplate/downloadasync'))
        break
      case 'exportTagTemplate':
        ;[err, res] = await To(instance.get('/api/Tag/DownloadTagInfoExcelTemplate'))
        break
      case 'exportTagClass':
        ;[err, res] = await To(
          instance.get(
            encodeUrl(
              `/api/TagClass/handover/ExportAsync/${arg.params.parentId || ' '}/${arg.params
                .keywords || ' '}/${arg.params.OrderBy || ' '}?isIncludeParent=${arg.params
                .isIncludeParent || false}`
            )
          )
        )
        break
      case 'exportTagAttrByKeyWord':
        ;[err, res] = await To(
          instance.get(
            encodeUrl(
              `/api/TagAttributeTemplate/exportasync/${arg.params.type}/${arg.params.keywords ||
                ' '}`
            )
          )
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiTagAttr(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'importExcel':
        ;[err, res] = await To(
          plantInstance.post('/api/TagAttributeTemplate/ImportExcelAsync', arg.formData)
        )
        break
      case 'getListPageByCondition':
        const getListPageByConditionObj = {
          pageNo: 1,
          pageSize: 10,
          sortName: ' ',
          sortType: 0,
          keywords: ' ',
        }
        if (arg.params) {
          _.assign(getListPageByConditionObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(`/api/TagAttributeTemplate/GetListPageByConditionAsync/
        ${getListPageByConditionObj.pageNo}/
        ${getListPageByConditionObj.pageSize}/
        ${getListPageByConditionObj.sortName}/
        ${getListPageByConditionObj.sortType}/
        ${getListPageByConditionObj.keywords}`)
          )
        )
        break
      case 'getTagAttributeTemplate':
        const getTagAttributeTemplateObj = {
          pageno: 1,
          pagesize: 10,
          keyword: '',
          class_id: ' ',
        }
        if (arg.params) {
          _.assign(getTagAttributeTemplateObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/std/StdClassAttribute?${qs.stringify(getTagAttributeTemplateObj)}`
          )
        )
        break
      case 'getTagAttributeTemplateById':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/TagAttributeTemplate/GetTagAttributeTemplateByIdAsync/${arg.params.id || ' '}`
            )
          )
        )
        break
      case 'add':
        // TODO need a default object
        ;[err, res] = await To(
          plantInstance.post('/api/TagAttributeTemplate/InsertAsync', arg.params)
        )
        break
      case 'modify':
        ;[err, res] = await To(
          plantInstance.post('/api/TagAttributeTemplate/ModifyAsync', arg.params)
        )
        break
      case 'remove':
        ;[err, res] = await To(plantInstance.post('/api/TagAttributeTemplate/RemoveAsync', arg.ids))
        break
      case 'getValueTypeList':
        ;[err, res] = await To(plantInstance.get('/api/TagAttributeTemplate/GetValueTypeListAsync'))
        break
      case 'getDicItemList':
        const obj = {
          pageNo: 1,
          pageSize: 100000000000000,
        }
        if (arg.params) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(`/api/UnitOfMessure/list/${obj.pageNo}/${obj.pageSize}`)
        )
        break
      case 'getDicCateList':
        ;[err, res] = await To(plantInstance.get('/api/TagAttributeTemplate/GetDicCateListAsync'))
        break
      case 'getListPageByName':
        ;[err, res] = await To(plantInstance.get('/api/TagAttrib/GetListPageByNameAsync'))
        break
      case 'getTDetail':
        ;[err, res] = await To(
          plantInstance.get(
            `/api/TagAttributeTemplateDetail/GetTagAttributeTemplateDetailByIdAsync/${arg.params
              .id || ' '}`
          )
        )
        break
      case 'addDetail':
        ;[err, res] = await To(
          plantInstance.post('/api/TagAttributeTemplateDetail/InsertAsync', arg.params)
        )
        break
      case 'modifyDetail':
        ;[err, res] = await To(
          plantInstance.post('/api/TagAttributeTemplateDetail/modifyasync', arg.params)
        )
        break
      case 'removeDetail':
        ;[err, res] = await To(
          plantInstance.post('/api/TagAttributeTemplateDetail/removeasync', arg.ids)
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiTagRelation(
    arg = {
      method: '',
      params: {},
      formData: {},
      files: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'RelatedFilesByTagAndDocumentClass':
        // TODO need a default object
        ;[err, res] = await To(
          plantInstance.post(
            '/api/Tag/GetRelatedFilesByTagAndDocumentClassAsync',
            _.assign(
              {
                siteId: '',
                tagId: '',
                fileId: '',
              },
              arg.params
            )
          )
        )
        break
      case 'RelatedToFilesWithTag':
        ;[err, res] = await To(
          plantInstance.post(`/api/tag/RelatedToFilesWithTagAsync/${arg.params.tagId}`, arg.files)
        )
        break
      case 'relationMainTagsByTag':
        const relationMainTagsByTagObj = {
          siteId: ' ',
          tagId: ' ',
          fileId: ' ',
        }
        if (arg.params) {
          _.assign(relationMainTagsByTagObj, arg.params)
        }
        // TODO need check the url
        ;[err, res] = await To(plantInstance.get('/api/tag/GetMainRelationDataByTagAsync/'))
        break
      case 'relationTagsByTagCode':
        const relationTagsByTagCodeObj = {
          siteId: '',
          tagCode: '',
          fileId: '',
        }
        if (arg.params) {
          _.assign(relationTagsByTagCodeObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.post('/api/Tag/GetRelationDataByTagCodeAsync', relationTagsByTagCodeObj)
        )
        break
      case 'relationFilesByTag':
        const relationFilesByTagObj = {
          siteId: ' ',
          tagId: ' ',
          fileId: ' ',
        }
        if (arg.params) {
          _.assign(relationFilesByTagObj, arg.params)
        }
        // TODO need check the url
        ;[err, res] = await To(plantInstance.get('/api/Tag/GetRelativeFileListByTag/'))
        break
      case 'relationTagsByFileCode':
        ;[err, res] = await To(
          plantInstance.post(
            '/api/Tag/GetRelationDataByFileCodeAsync',
            _.assign(
              {
                FileId: ' ',
                SiteId: '',
                TagCode: ' ',
              },
              arg.params
            )
          )
        )
        break
      case 'relationTagsByFile':
        const projectObj = {
          siteId: ' ',
          tagCode: ' ',
        }
        if (arg.params) {
          _.assign(projectObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/Tag/GetRelationDataByFileAsync/${arg.params.siteId || ' '}/${arg.params
                .tagCode || ' '}`
            )
          )
        )
        break
      case 'relationTagsByTag':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/Tag/GetRelationDataByTagAsync/${arg.params.siteId || ' '}/${arg.params.tagId ||
                ' '}`
            )
          )
        )
        break
      case 'relationTags':
        ;[err, res] = await To(
          plantInstance.get(`/api/Tag/GetTagRelation/${arg.params.tagId || ' '}`)
        )
        break
      case 'relatedToTag':
        ;[err, res] = await To(plantInstance.post('/api/Document/related_to_tag', arg.params))
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiTagsClass(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
      standard_id: '',
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'tagClassTree':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(arg.params)}`)
        )
        break
      case 'superiorTagClassTree':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(`/api/TagClass/getsuperiortagclasstreeasync/${arg.params.id || ' '}`)
          )
        )
        break
      case 'tagById':
        ;[err, res] = await To(
          plantInstance.get(encodeUrl(`/api/TagClass/GetTagClassViewAsync/${arg.params.id || ' '}`))
        )
        break
      case 'deleteTagClassDump':
        // TODO need double check
        ;[err, res] = await To(
          plantInstance.post(`/api/TagClass/removetagasync/${arg.params.id || ' '}`, arg.formData)
        )
        break
      case 'deleteTagClass':
        ;[err, res] = await To(plantInstance.post('/api/TagClass/RemoveAsync', arg.ids))
        break
      case 'updateTagClass':
        ;[err, res] = await To(plantInstance.post('/api/TagClass/ModifyAsync', arg.params))
        break
      case 'addTagClass':
        // TODO need a default object
        ;[err, res] = await To(plantInstance.post('/api/TagClass/InsertAsync', arg.params))
        break
      case 'importExcel':
        ;[err, res] = await To(plantInstance.post('/api/TagClass/ImportExcelAsync', arg.formData))
        break
      case 'tagClassByNameDump':
        // TODO need double check
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/TagClass/GetListByNameAsync/${arg.params.keywords || ' '}/${arg.params
                .parentId || ' '}`
            )
          )
        )
        break
      case 'tagClassByName':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/TagClass/GetListByNameAsync/${arg.params.keywords || ' '}/${arg.params
                .parentId || ' '}`
            )
          )
        )
        break
      case 'tagClassByCondition':
        const tagClassByConditionObj = {
          pageNo: 1,
          pageSize: 10,
          sortName: ' ',
          sortType: 0,
          parentId: ' ',
          keyWord: ' ',
          isIncludeParent: false,
        }
        if (arg.params) {
          _.assign(tagClassByConditionObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/TagClass/GetListPageByConditionAsync/${tagClassByConditionObj.pageNo}/${tagClassByConditionObj.pageSize}/${tagClassByConditionObj.sortName}/${tagClassByConditionObj.sortType}/${tagClassByConditionObj.parentId}/${tagClassByConditionObj.keyWord}?isIncludeParent=${tagClassByConditionObj.isIncludeParent}`
            )
          )
        )
        break
      case 'tagClassBySite':
        const tagClassBySiteObj = {
          siteId: ' ',
          pageNo: 1,
          pageSize: 10,
          parentId: ' ',
          keyWord: ' ',
        }
        if (arg.params) {
          _.assign(tagClassBySiteObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(`/api/TagClass/GetTagListByAsync/
        ${tagClassBySiteObj.siteId}/
        ${tagClassBySiteObj.pageNo}/
        ${tagClassBySiteObj.pageSize}/
        ${tagClassBySiteObj.parentId}/
        ${tagClassBySiteObj.keyWord}`)
          )
        )
        break
      case 'tagClassByClassId':
        const tagClassByClassIdObj = {
          classId: ' ',
          isRelation: 1,
          pageNo: 1,
          pageSize: 10,
          keyWord: ' ',
        }
        if (arg.params) {
          _.assign(tagClassByClassIdObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/TagClass/GetTagListByClassIdAsync/${tagClassByClassIdObj.classId}/${tagClassByClassIdObj.siteId}/ ${tagClassByClassIdObj.isRelation}/ ${tagClassByClassIdObj.pageNo}/ ${tagClassByClassIdObj.pageSize}/ ${tagClassByClassIdObj.keyWord}`
            )
          )
        )
        break
      case 'tagClassIons':
        ;[err, res] = await To(plantInstance.get('/api/TagClass/GetIconListAsync'))
        break
      case 'tagAttrTemplate':
        // TODO need double check
        ;[err, res] = await To(
          plantInstance.get('/api/TagClass/GetTagAttributeTemplateListByCodeOrNameAsync')
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiTags(
    arg = {
      method: '',
      params: {},
      formData: {},
      tagIdList: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'list':
        const listObj = {
          id: ' ',
          pageIndex: '',
          pageSize: '',
          standardId: '',
        }
        if (arg.params) {
          _.assign(listObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/std/Tag/tag-obj-data?${qs.stringify(listObj)}`)
        )
        break
      case 'docRelationFile':
        const docRelationFileObj = {
          id: ' ',
          standardId: '',
        }
        if (arg.params) {
          _.assign(docRelationFileObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(`/api/std/Tag/associated-files?${qs.stringify(docRelationFileObj)}`)
          )
        )
        break
      case 'modelBreakDown':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/std/Document/GetModelBreakdownsAsync', arg.params)
        )
        break
      case 'tagIdentifierToInfo':
        ;[err, res] = await To(
          plantInstance.post('/api/Tag/identifier_convert_to_info', arg.params)
        )
        break
      case 'tagIdentifier':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(`/api/Tag/GetIdentifier/${arg.params.tagId}/${arg.params.fileId}`)
          )
        )
        break
      case 'modelByTag':
        ;[err, res] = await To(plantInstance.get('/api/Tag/GetModelFilesByTag/'))
        break
      case 'generateAttr':
        ;[err, res] = await To(plantInstance.get('/api/tag/gettaggeneralattributelistasync'))
        break
      case 'importExcel':
        ;[err, res] = await To(
          plantInstance.post('/api/Tag/ImportTagObjFromFileAsync', arg.formData)
        )
        break
      case 'tagRecord':
        ;[err, res] = await To(
          plantInstance.get(`/api/Tag/GetTagRecord/${arg.params.tagId || ' '}`)
        )
        break
      case 'tagDifference':
        ;[err, res] = await To(
          plantInstance.get(`/api/Tag/GetTagDifference/${arg.params.batchNo || ' '}`)
        )
        break
      case 'addTag':
        ;[err, res] = await To(plantInstance.post('/api/tag/AddTagObjAsync', arg.params))
        break
      case 'updateTag':
        ;[err, res] = await To(plantInstance.post('/api/tag/UpdateTagObjAsync', arg.params))
        break
      case 'deleteTag':
        ;[err, res] = await To(plantInstance.post('/api/tag/DeleteTagObjAsync', arg.tagIdList))
        break
      case 'addBlankTag':
        ;[err, res] = await To(plantInstance.post('/api/Tag/main', arg.params))
        break
      case 'updateBlankTag':
        ;[err, res] = await To(plantInstance.patch('/api/Tag/main', arg.params))
        break
      case 'queryBlankTag':
        ;[err, res] = await To(plantInstance.post('/api/Tag/query_main', arg.params))
        break
      case 'tags':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(
              `/api/tag/GetTagObjDataAsync/${arg.params.tagId || ' '}/${arg.params.pageNo ||
                1}/${arg.params.pageSize || 10}`
            )
          )
        )
        break
      case 'parentTagsByNameOrCode':
        const parentTagsByNameOrCodeObj = {
          keyword: ' ',
          standardId: ' ',
        }
        if (arg.params) {
          _.assign(parentTagsByNameOrCodeObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/std/Tag/list-by-code-or-name?${qs.stringify(parentTagsByNameOrCodeObj)}`
            )
          )
        )
        break
      case 'templateAttrByTagClass':
        ;[err, res] = await To(
          plantInstance.get(
            encodeUrl(`/api/Tag/GetTemplateAttrSetByTagClassAsync/${arg.params.tagClassId || ' '}`)
          )
        )
        break
      case 'relativeFileByTagCode':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/std/TagFileAssociation/many', arg.params)
        )
        break
      case 'DetachAssociationByTagAndFileList':
        ;[err, res] = await To(
          wizStandardInstance.delete('/api/std/TagFileAssociation/many', { data: arg.params })
        )
        break
      case 'tagsByCodeGet':
        // TODO need double check
        ;[err, res] = await To(plantInstance.get('/api/tag/GetTagObjDataByCodeAsync/'))
        break
      case 'tagsByCode':
        ;[err, res] = await To(
          plantInstance.post(
            '/api/tag/GetTagObjDataByCodeAsync',
            _.assign(
              {
                siteId: ' ',
                tagCode: ' ',
                fileId: ' ',
              },
              arg.params
            )
          )
        )
        break
      case 'tagsByNameOrCode':
        // TODO need check the url
        await To(
          plantInstance.get(
            encodeUrl(
              `/api/tag/GetTagListByNameOrCodeAsync/${obj.siteId}/${obj.pageNo}/${obj.pageSize}/${obj.orderBy}/${obj.isAsc}/${obj.keywords}`
            )
          )
        )
        break
      case 'tagPageByCondition':
        const tagPageByConditionObj = {
          where: {
            siteId: '',
            keyWord: '',
            classId: [],
          },
          dataPage: {
            pageNo: 1,
            pageSize: 10,
          },
          orderBy: [
            {
              name: 'code',
              order: 0,
            },
          ],
        }
        if (arg.params) {
          _.assign(tagPageByConditionObj, arg.params)
        }
        ;[err, res] = await To(plantInstance.post('/api/Tag/query_main', tagPageByConditionObj))
        break
      case 'getFileList':
        const getFileListObj = {
          StandardId: ' ',
          SkipCount: 1,
          MaxResultCount: 10,
          KeyWord: ' ',
        }
        if (arg.params) {
          _.assign(getFileListObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/std/Document/get_file_document_list?${qs.stringify(getFileListObj)}`
          )
        )
        break
      case 'queryTagsNotAssociatedWithDocumentFile':
        const queryTagsNotAssociatedWithDocumentFileObj = {
          Condition: '',
          DataPage: {
            pageNo: 1,
            pageSize: 10,
          },
          Where: {
            DocumentFileId: '',
            Keywords: '',
            SiteId: '',
            TagClissIdList: '',
            OrderBy: [
              {
                name: 'Code',
                order: 0,
              },
            ],
          },
        }
        if (arg.params) {
          _.assign(queryTagsNotAssociatedWithDocumentFileObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.post(
            '/api/DocumentFile/query_tags_not_associated_with_document_file_async',
            queryTagsNotAssociatedWithDocumentFileObj
          )
        )
        break
      case 'associateTagWithDocumentFile':
        const associateTagWithDocumentFileObj = {}
        if (arg.params) {
          _.assign(associateTagWithDocumentFileObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.post(
            '/api/DocumentFile/associate_tag_with_document_file_async',
            associateTagWithDocumentFileObj
          )
        )
        break
      case 'relieveAssociatedWithDocumentFile':
        const relieveAssociatedWithDocumentFileObj = {}
        if (arg.params) {
          _.assign(relieveAssociatedWithDocumentFileObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.post(
            `/api/DocumentFile/relieve_associated_with_document_file_async/
        ${relieveAssociatedWithDocumentFileObj.fileId}`,
            relieveAssociatedWithDocumentFileObj.tagIdList
          )
        )
        break
      case 'tagsTemplate':
        const templateObj = {}
        if (arg.params) {
          _.assign(templateObj, arg.params)
        }
        ;[err, res] = await To(
          plantInstance.get(`/api/share/common/get_tag_template_list?${qs.stringify(templateObj)}`)
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },

  async apiMonomerModels(
    arg = {
      method: '',
      params: {},
      formData: {},
      ids: [],
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'add':
        ;[err, res] = await To(plantInstance.post('/api/Tag/mono_building', arg.formData))
        break
      case 'update':
        ;[err, res] = await To(plantInstance.patch('/api/Tag/mono_building', arg.formData))
        break
      case 'delete':
        ;[err, res] = await To(
          plantInstance.delete('/api/Tag/mono_building', {
            data: arg.params,
          })
        )
        break
      case 'init':
        ;[err, res] = await To(plantInstance.post('/api/Tag/query_mono_building', arg.params))
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinTagObject,
}
